/* eslint-disable */
export const MAX_KW_VOLUME_TIERS = 6;

export function getKwVolumePathDepth(path) {
  const arr = Array.isArray(path) ? path : [];
  let depth = 0;
  for (let i = 0; i < MAX_KW_VOLUME_TIERS; i += 1) {
    const slot = arr[i];
    if (
      slot == null ||
      slot === '' ||
      slot === 0 ||
      (typeof slot === 'object' && (slot.value == null || slot.value === ''))
    ) {
      break;
    }
    depth += 1;
  }
  return depth;
}

export function getKwVolumeNextLevelItems(categories, depth) {
  const kwNextLevel = depth + 1;
  if (kwNextLevel < 1 || kwNextLevel > MAX_KW_VOLUME_TIERS) return [];
  const rows =
    categories && categories[`category${kwNextLevel}`]
      ? categories[`category${kwNextLevel}`]
      : [];
  return Array.isArray(rows) ? rows : [];
}

/** 子カテゴリがまだ選べる／読込中なら末端登録は不可 */
export function kwVolumeHasMoreTiersToPick({
  categories,
  path,
  childrenLoading
}) {
  const depth = getKwVolumePathDepth(path);
  if (depth >= MAX_KW_VOLUME_TIERS) return false;
  const kwNextLevel = depth + 1;
  const nextItems = getKwVolumeNextLevelItems(categories, depth);
  const awaitingChildren =
    childrenLoading && depth > 0 && kwNextLevel > 1;
  return awaitingChildren || nextItems.length > 0;
}

export function formatKwVolumePathLabels(path, { leafOnly = false } = {}) {
  const arr = Array.isArray(path) ? path : [];
  const withLabel = arr.filter((x) => x && typeof x === 'object' && x.label);
  if (withLabel.length === 0) return '（未選択）';
  if (leafOnly) return withLabel[withLabel.length - 1].label;
  return withLabel.map((x) => x.label).join(' › ');
}
